export const CONSTANTS = {
  acceptedImageTypes: ["image/jpeg", "image/png", "image/gif", "image/webp"],
}
